function getPayload(request) {
  return request.text();
}
export {
  getPayload
};
